// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.scss\"","smallWidth":"768px","header":"LogoCategory_header__2CbJU","logos":"LogoCategory_logos__2rqyZ"};